import {
  QueryKey,
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "react-query";

// strict means it will throw on error
export function useStrictQuery<TData, TError extends object = any>(
  key: QueryKey,
  queryFn: () => Promise<TData>,
  options?: UseQueryOptions<TData, TError>
): UseQueryResult<TData, TError> {
  const componentKey = Array.isArray(key) ? key.join("/") : String(key);
  const result = useQuery<TData, TError>(key, queryFn, options);

  if (result.isError) {
    throw Object.assign(result.error, { componentKey });
  }

  return result;
}
